module.exports = __webpack_public_path__ + "img/dfc.a7cc98ec.png";